export default "__VITE_ASSET__CvFs_a_u__"